import { hexToRgb } from './hexToRgb';

export const hexToRgba = (baseColor: string, alpha = 1) => {
  const { r, g, b } = hexToRgb(baseColor);

  return `rgba(${r}, ${g}, ${b}, ${Math.min(alpha, 1)})`;
};
